import { render, staticRenderFns } from "./MaterialRewardModal.vue?vue&type=template&id=ec83076e&"
import script from "./MaterialRewardModal.vue?vue&type=script&lang=js&"
export * from "./MaterialRewardModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRewardModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports